import styled, { css } from 'styled-components';
export const ListItemWrapper = styled.li `
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  list-style: none;
  height: 56px;
  padding: 0 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  cursor: pointer;

  ${({ theme, variant }) => theme.listItem[variant].common};

  ${({ isTargeted, theme, variant }) => isTargeted && theme.listItem[variant].targeted};

  &[aria-selected='true'] {
    ${({ theme, variant }) => theme.listItem[variant].targeted};
  }

  ${({ disabled }) => disabled &&
    css `
      pointer-events: none;
    `};

  ${({ type }) => {
    switch (type) {
        case 'Group':
            return css `
          ${({ theme }) => theme.fonts.PoppinsTextBold};
          pointer-events: none;
        `;
        case 'Standard':
            return css ``;
        case 'Indented':
            return css `
          padding-left: 40px;
        `;
        default:
            return css ``;
    }
}}
`;
export const ListItemCheckWrapper = styled.div `
  height: 100%;
  display: flex;
  min-width: 40px;
  width: 40px;
  max-width: 40px;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=BKJListItem.styled.js.map